"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var keyValueValidate_exports = {};
__export(keyValueValidate_exports, {
  assertOpen: () => assertOpen,
  requireKey: () => requireKey,
  requireName: () => requireName,
  requireValue: () => requireValue
});
module.exports = __toCommonJS(keyValueValidate_exports);
var NAME_PATTERN = /^[A-Za-z0-9._-]{1,128}$/;
function requireName(name) {
  if (typeof name !== "string" || !NAME_PATTERN.test(name)) {
    throw new Error("Database.openKeyValue: name must be 1-128 letters, digits, dots, underscores, or hyphens");
  }
  return name;
}
function requireKey(verb, key) {
  if (typeof key !== "string" || key === "") {
    throw new Error(`${verb}: key must be a non-empty string`);
  }
  return key;
}
function requireValue(verb, value) {
  if (typeof value !== "string") {
    throw new Error(`${verb}: value must be a string`);
  }
  return value;
}
function assertOpen(verb, closed) {
  if (closed) throw new Error(`${verb}: key-value store is closed`);
}
//# sourceMappingURL=keyValueValidate.js.map
